export abstract class EnumFilter<T> {
    public removeFilterValue:string = "Enlever le filtre";
    public values:Array<string>;
    public defaultValue:string;
    public selectedValue:string;

    constructor(defaultValue: string) {
        this.values = [];
        this.defaultValue = defaultValue;
        this.selectedValue = defaultValue;
    }

    protected Initialize(values){
        for (let item in values) {
            if (isNaN(Number(item))) {
                this.values.push(item.replace("_", " "))
            }
        }
        this.values.sort();
    }
    public abstract valueSelected(value:string);

    protected HideRemoveFilterValue(){
        this.selectedValue = this.defaultValue;

        var that = this;
        setTimeout(() => {
            that.values.splice(0, 1);
        }, 500);
    }


    protected DisplayRemoveFilterValue(){
        var that = this;
        setTimeout(() => {
            that.values.unshift(this.removeFilterValue);
        }, 500);
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/occasions/content/occasions-filter/filters/EnumFilter.ts